import LoginVerify from "../../../../jsx/pages/Connector/LoginVerify";

const LoginVerifyWrapper = function (props) {
  return <LoginVerify />;
};

export default constore(LoginVerifyWrapper);
